import { crearImpresoraRoutes, IMPRESION_DOCUMENTO, impresoraRoutesMap } from '../base/Impresora'

export const impresorasRoutesMap = {
  ...impresoraRoutesMap,
}

const impresorasRoutes = [
  ...crearImpresoraRoutes({
    documentos: [
      IMPRESION_DOCUMENTO.FACTURA,
      IMPRESION_DOCUMENTO.CAJA,
      IMPRESION_DOCUMENTO.COMANDA,
      IMPRESION_DOCUMENTO.RETIRO_CAJA,
      IMPRESION_DOCUMENTO.ESTADO_CUENTA,
    ],
  }),
]

export default impresorasRoutes
